'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeHelper = undefined;

var _ThemeHelper2 = require('./ThemeHelper');

var _ThemeHelper3 = _interopRequireDefault(_ThemeHelper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThemeHelper = _ThemeHelper3.default;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/theme/index.js
// module id = 1860
// module chunks = 0